module.exports = __webpack_public_path__ + "img/avantage2.749e62ac.png";